// Settings.js
import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Modal, Button, Row, Col, Form, Image } from "react-bootstrap";
import FeaturedBoats from "../frontend/FeaturedBoats";
import {
  get,
  getDatabase,
  ref,
  set,
  update,
  onValue,
  off,
  push,
  remove,
} from "firebase/database";
import {
  getAllOwnerTextQuestions,
  getCurrentUserDetails,
  getOwnerMetaByID,
  getUserMetaByID,
  getDateOfBirthFromUserMeta,
  calculateAgeFromDateOfBirth,
} from "../utils";
import { useAuth } from "../../contexts/AuthContext";
import { Alert } from "@mui/material";
import { ThreeDots } from "react-loader-spinner";
import { IoBoatOutline } from "react-icons/io5";
import Cropper from "react-cropper"; // Import Cropper component and types
import "cropperjs/dist/cropper.css"; // Import Cropper CSS
import StripeConnectSettings from "./StripeConnectSettings"; // Import the Stripe Connect component

const isTaxIdentifierQuestion = (question = "") => {
  const normalizedQuestion = question.trim().toLowerCase();

  return (
    normalizedQuestion.includes("social security") ||
    normalizedQuestion.includes("ssn") ||
    normalizedQuestion.includes("ein") ||
    normalizedQuestion.includes("tax id") ||
    normalizedQuestion.includes("tax identification") ||
    normalizedQuestion.includes("taxpayer identification") ||
    normalizedQuestion.includes("xxx-xx-xxxx")
  );
};

export default function Settings() {
  const navigate = useNavigate();
  const [showPayPalModal, setShowEditModal] = useState(false);
  const [isBecomeBoatOwnerModalOpen, setBecomeBoatOwnerModal] = useState(false);
  const [userData, setUserData] = useState([]);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [metaData, setMetaData] = useState([]);
  const [paypalData, setPaypalData] = useState([]);

  const cropperRef = useRef(null); // Create a ref to the Cropper component
  const [croppedImage, setCroppedImage] = useState(null);

  const serverUrl = process.env.REACT_APP_BASE_URL;

  const openBecomeBoatOwnerModal = async () => {
    const textQuestionsData = await getAllOwnerTextQuestions();
    const testQuestionsArray = Object.values(textQuestionsData).filter(
      (question) =>
        question.trim().toLowerCase() !== "address line 2" &&
        !isTaxIdentifierQuestion(question)
    );
    console.log(testQuestionsArray);
    setTextQuestions(testQuestionsArray);
    setBecomeBoatOwnerModal(true);
  };

  const closeBecomeBoatOwnerModal = () => {
    setBecomeBoatOwnerModal(false);
  };
  const auth = useAuth();
  const { updatePassword, updateEmail, reauthenticate } = useAuth();

  const [formValues, setFormValues] = useState({
    country: "United States",
    currency: "USD",
    accountHolderFirst: "",
    accountHolderLast: "",
    accountHolderAddress: "",
    accountHolderEmail: "",
    accountHolderCity: "",
    accountHolderState: "",
    accountHolderZip: "",
  });

  const [userValues, setUserValues] = useState({
    email: "",
    phone: "",
    firstName: "",
    lastName: "",
    avatar: "",
    dateOfBirth: "",
  });

  const openEditModal = () => {
    console.log("Open");
    setShowEditModal(true);
  };

  const closePaypalModal = () => {
    setShowEditModal(false);
  };

  const [isBoatTypeModelOpen, setBoatTypeModelOpen] = useState(false);
  const openBoatTypeModal = (index) => {
    setSelectedBoatTypeIndex(index);
    setBoatTypeModelOpen(true);
  };

  const closeBoatTypeModal = () => {
    setBoatTypeModelOpen(false);
    setSelectedBoatTypeIndex(null);
  };

  const [textQuestions, setTextQuestions] = useState([]);
  const [boatTypes, setBoatTypes] = useState([]);
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userDetails = await getCurrentUserDetails();
        const metaDetails = await getOwnerMetaByID(userDetails["userId"]);
        const userMeta = await getUserMetaByID(userDetails["userId"]);
        setPaypalData(metaDetails);
        const filteredUserDetails = Object.keys(userValues).reduce(
          (acc, key) => {
            if (userDetails.hasOwnProperty(key)) {
              acc[key] = userDetails[key];
            }
            return acc;
          },
          {}
        );

        // Update userValues with the filtered values from userDetails
        setUserValues((prevUserValues) => ({
          ...prevUserValues,
          ...filteredUserDetails,
          dateOfBirth: getDateOfBirthFromUserMeta(userMeta) || "",
        }));

        console.log("userValues");
        console.log(userValues);
        // Check if metaDetails and metaDetails['payoutAccounts'] are truthy
        if (metaDetails && metaDetails["payoutAccounts"]) {
          const payPalData = metaDetails["payoutAccounts"]["Paypal"];
          setPaypalData(payPalData);
        }
        setUserData(userDetails);
        setMetaData(metaDetails);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, []);

  useEffect(() => {
    const database = getDatabase();
    const boatTypesRef = ref(database, "portalSettings/settingsID/boatTypes");

    const handleData = (snapshot) => {
      if (snapshot.exists()) {
        const boatTypesData = Object.entries(snapshot.val()).map(
          ([id, value]) => ({
            id,
            value,
          })
        );
        setBoatTypes(boatTypesData);
      } else {
        console.log("No data found");
        setBoatTypes([]);
      }
    };

    onValue(boatTypesRef, handleData);

    // Clean up the listener when the component unmounts
    return () => {
      // Detach the event listener
      off(boatTypesRef, "value", handleData);
    };
  }, []);

  const [platformCut, setPlatformCut] = useState(0);
  const [platformCutDisplay, setPlatformCutDisplay] = useState(0);
  const handlePlatformCut = (value) => {
    setPlatformCutDisplay(value);
    const numericValue = parseFloat(value);
    if (!isNaN(numericValue) && numericValue >= 0) {
      const val = numericValue / 100;
      setPlatformCut(val);
    } else if (value === '') {
      setPlatformCut(0);
    }
  };

  const [platformOtherTypeCut, setPlatformOtherTypeCut] = useState(0);
  const [platformOtherTypeCutDisplay, setPlatformOtherTypeCutDisplay] = useState(0);
  const handlePlatformOtherTypeCut = (value) => {
    setPlatformOtherTypeCutDisplay(value);
    const numericValue = parseFloat(value);
    if (!isNaN(numericValue) && numericValue >= 0) {
      const val = numericValue / 100;
      setPlatformOtherTypeCut(val);
    } else if (value === '') {
      setPlatformOtherTypeCut(0);
    }
  };
  useEffect(() => {
    const database = getDatabase();
    const platformCutRef = ref(
      database,
      "portalSettings/settingsID/defaultAdminCut"
    );

    const handleData = (snapshot) => {
      const value = snapshot.val() || 0;
      setPlatformCut(value);
      setPlatformCutDisplay((value * 100).toFixed(2));
    };

    onValue(platformCutRef, handleData);

    // Clean up the listener when the component unmounts
    return () => {
      // Detach the event listener
      off(platformCutRef, "value", handleData);
    };
  }, []);

  useEffect(() => {
    const database = getDatabase();
    const platformOtherTypeCutRef = ref(
      database,
      "portalSettings/settingsID/defaultOtherBoatTypeAdminCut"
    );

    const handleData = (snapshot) => {
      const value = snapshot.val() || 0;
      setPlatformOtherTypeCut(value);
      setPlatformOtherTypeCutDisplay((value * 100).toFixed(2));
    };

    onValue(platformOtherTypeCutRef, handleData);

    // Clean up the listener when the component unmounts
    return () => {
      // Detach the event listener
      off(platformOtherTypeCutRef, "value", handleData);
    };
  }, []);

  const addPayPalDataToDatabase = async (userId, formData) => {
    const database = getDatabase();
    const userRef = ref(database, `ownerMeta/${userId}`);

    try {
      await update(userRef, {
        "payoutAccounts/Paypal": formData,
      });
      console.log("PayPal data added to user successfully");
    } catch (error) {
      console.error("Error adding PayPal data to user:", error);
      throw error;
    }
  };

  const [selectedBoatTypeIndex, setSelectedBoatTypeIndex] = useState(null);

  const handleRemoveBoatType = async () => {
    try {
      const boatTypeRef = ref(
        getDatabase(),
        `portalSettings/settingsID/boatTypes/${selectedBoatTypeIndex}`
      );
      await remove(boatTypeRef);
      setSuccess("Boat Type has been removed.");
      setTimeout(() => {
        setSuccess("");
        setSelectedBoatTypeIndex(null);
        closeBoatTypeModal();
      }, 1400);
    } catch (error) {}
  };

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  // 2FA Flow State
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otpStep, setOtpStep] = useState(1); // 1: verify current, 2: enter new, 3: verify new
  const [otpType, setOtpType] = useState(""); // "email" or "phone"
  const [verifyMethod, setVerifyMethod] = useState(""); // "email" or "phone"
  const [currentOtpValue, setCurrentOtpValue] = useState("");
  const [newContactValue, setNewContactValue] = useState("");
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [resendTimer, setResendTimer] = useState(0);

  useEffect(() => {
    let interval = null;
    if (resendTimer > 0) {
      interval = setInterval(() => {
        setResendTimer(prev => prev - 1);
      }, 1000);
    } else if (interval) {
      clearInterval(interval);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [resendTimer]);

  const initiateChange = (type) => {
    setOtpType(type);
    setVerifyMethod(userData.email ? "email" : "phone");
    setOtpStep(0);
    setShowOtpModal(true);
    setOtpError("");
    setOtpLoading(false);
    setCurrentOtpValue("");
    setNewContactValue("");
    setResendTimer(0);
  };

  const handleRequestCurrent = async () => {
    setOtpLoading(true);
    setOtpError("");
    try {
      const currentValue = verifyMethod === "email" ? userData.email : userData.phone;
      if (!currentValue) throw new Error(`No ${verifyMethod} linked to your account.`);
      const response = await fetch(`${serverUrl}/request-verification`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId: auth.currentUser.uid, type: verifyMethod, newValue: currentValue, method: "current" })
      });
      const data = await response.json();
      if (!data.success) throw new Error(data.error);
      
      setOtpStep(1);
      setResendTimer(60);
    } catch (err) {
      setOtpError(err.message || "Failed to send verification code");
    } finally {
      setOtpLoading(false);
    }
  };

  const handleVerifyCurrent = async () => {
    setOtpLoading(true);
    setOtpError("");
    try {
      const response = await fetch(`${serverUrl}/verify-code`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId: auth.currentUser.uid, type: verifyMethod, method: "current", code: currentOtpValue })
      });
      const data = await response.json();
      if (!data.success) throw new Error(data.error);
      
      setOtpStep(2);
      setCurrentOtpValue("");
    } catch (err) {
      setOtpError(err.message || "Invalid code");
    } finally {
      setOtpLoading(false);
    }
  };

  const handleRequestNew = async () => {
    if (!newContactValue) {
      setOtpError(`Please enter a valid ${otpType}`);
      return;
    }
    setOtpLoading(true);
    setOtpError("");
    try {
      const response = await fetch(`${serverUrl}/request-verification`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId: auth.currentUser.uid, type: otpType, newValue: newContactValue, method: "new" })
      });
      const data = await response.json();
      if (!data.success) throw new Error(data.error);
      
      setOtpStep(3);
      setCurrentOtpValue("");
      setResendTimer(60);
    } catch (err) {
      setOtpError(err.message || "Failed to send verification code");
    } finally {
      setOtpLoading(false);
    }
  };

  const handleVerifyNew = async () => {
    setOtpLoading(true);
    setOtpError("");
    try {
      const response = await fetch(`${serverUrl}/verify-code`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId: auth.currentUser.uid, type: otpType, method: "new", code: currentOtpValue })
      });
      const data = await response.json();
      if (!data.success) throw new Error(data.error);
      
      const updateResponse = await fetch(`${serverUrl}/confirm-update`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId: auth.currentUser.uid, type: otpType, newValue: newContactValue })
      });
      const updateData = await updateResponse.json();
      if (!updateData.success) throw new Error(updateData.error);

      setSuccess(`${otpType === 'email' ? 'Email' : 'Phone'} updated successfully!`);
      setTimeout(() => setSuccess(""), 3000);
      setShowOtpModal(false);
      
      setUserValues(prev => ({ ...prev, [otpType]: newContactValue }));
      setUserData(prev => ({ ...prev, [otpType]: newContactValue }));
    } catch (err) {
      setOtpError(err.message || "Invalid code");
    } finally {
      setOtpLoading(false);
    }
  };
  const updateUserData = async (userId) => {
    setLoading(true);
    const database = getDatabase();
    const userRef = ref(database, `users/${userId}`);
    try {
      const userSnapshot = await get(userRef);
      let existingUserData = userSnapshot.exists() ? userSnapshot.val() : null;

      const updatedUserData = {
        ...existingUserData,
        firstName: userValues.firstName,
        lastName: userValues.lastName,
        avatar: userValues.avatar,
      };
      
      await update(userRef, updatedUserData);

      if (userValues.dateOfBirth) {
        const userAge = calculateAgeFromDateOfBirth(userValues.dateOfBirth);
        const userMetaRef = ref(database, `userMeta/${userId}`);
        await update(userMetaRef, {
          dateOfBirth: userValues.dateOfBirth,
          age: userAge,
        });
      }

      console.log("User updated");
      setLoading(false);
      setSuccess("Information has been updated.");
      setTimeout(() => {
        setSuccess("");
      }, 1300);
    } catch (error) {
      console.error("Error updating user:", error);
      setLoading(false);
      setError(error.message || "Failed to update profile.");
      setTimeout(() => setError(""), 3000);
    }
  };

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userDetails = await getCurrentUserDetails();
        const metaDetails = await getOwnerMetaByID(userDetails["userId"]);

        if (metaDetails && metaDetails["payoutAccounts"]) {
          const payPalData = metaDetails["payoutAccounts"]["Paypal"];
          setFormValues(payPalData);
        }

        setUserData(userDetails);
        setMetaData(metaDetails);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, []);

  const [textQuestionAnswers, setTextQuestionAnswers] = useState([]);

  async function handleBecomeBoatOwner(e) {
    e.preventDefault();

    try {
      setError("");
      setLoading(true);

      // Store user information in the Realtime Database under 'users' node
      const userRef = ref(getDatabase(), `users/${auth.currentUser.uid}`);
      await update(userRef, { role: "Boat Owner" });
      const ownerMetaRef = ref(
        getDatabase(),
        `ownerMeta/${auth.currentUser.uid}`
      );

      await set(ownerMetaRef, {
        payments: {
          currentAmount: 0,
          totalAmount: 0,
        },
        totalPaidBookings: 0,
      });

      const userMetaRef = ref(
        getDatabase(),
        `userMeta/${auth.currentUser.uid}/userAnswers`
      );
      await update(userMetaRef, {
        textQuestions: textQuestions.map((question, index) => ({
          question: question,
          answer: textQuestionAnswers[index]?.answer || "",
        })),
      });

      setSuccess("Your role has been changed to Boat Owner.");
      setTimeout(() => {
        setSuccess("");
        closeBecomeBoatOwnerModal();
      }, 1300);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  const [avatar, setAvatar] = useState(null);

  const onCrop = () => {
    const cropper = cropperRef.current.cropper; // Access the Cropper instance through the ref
    setCroppedImage(cropper.getCroppedCanvas().toDataURL());
  };

  const handleUploadAvatar = async () => {
    if (croppedImage) {
      // Convert the base64 image to a Blob
      const blob = await fetch(croppedImage).then((res) => res.blob());
      console.log(blob);
      // Create FormData and append the file
      const formData = new FormData();
      formData.append("file", blob);

      try {
        const response = await fetch(`${serverUrl}/upload-featured-image`, {
          method: "POST",
          body: formData,
        });

        if (response.ok) {
          const responseData = await response.json();
          setUserValues((prevUserValues) => ({
            ...prevUserValues,
            avatar: `${serverUrl}/images/${responseData.file_name}`,
          }));
          setAvatar(null);
        } else {
          console.error("File upload failed");
        }
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    } else {
      console.error("No cropped image available");
    }
  };

  const handleSelectImage = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = () => {
      setAvatar(reader.result); // Set the file URL as the avatar
    };
    reader.readAsDataURL(file); // Convert the file to a data URL
  };

  const handleChange = (e, question) => {
    const { name, value } = e.target;

    if (name.startsWith("question_")) {
      // Update textfield answers
      const questionIndex = parseInt(name.split("_")[1], 10);
      const existingAnswerIndex = textQuestionAnswers.findIndex(
        (answer) => answer.questionText === textQuestions[questionIndex]
      );

      if (existingAnswerIndex !== -1) {
        // If an answer exists, update the existing answer
        setTextQuestionAnswers((prevAnswers) => {
          const updatedAnswers = [...prevAnswers];
          updatedAnswers[existingAnswerIndex] = {
            questionText: textQuestions[questionIndex],
            answer: value,
          };
          return updatedAnswers;
        });
      } else {
        // If no answer exists, add a new answer to the array
        setTextQuestionAnswers((prevAnswers) => [
          ...prevAnswers,
          {
            questionText: textQuestions[questionIndex],
            answer: value,
          },
        ]);
      }
    } else {
      // Update other form data
      setFormValues((prevData) => ({ ...prevData, [name]: value }));
    }
    console.log(textQuestionAnswers);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setUserValues((prevUserValues) => ({
      ...prevUserValues,
      [name]: value,
    }));
    console.log(userValues);
  };

  const handleSetNewPassword = async () => {
    try {
      if (!currentPassword) {
        setError("Please enter your current password.");
        setTimeout(() => setError(""), 2000);
        return;
      }
      if (newPassword.length < 8) {
        setError("Password should be at least 8 characters long.");
        setTimeout(() => setError(""), 2000);
        return;
      } 
      if (newPassword !== confirmPassword) {
        setError("Passwords do not match.");
        setTimeout(() => setError(""), 2000);
        return;
      }

      await reauthenticate(currentPassword);
      await updatePassword(newPassword);
      
      setSuccess("Your password has been updated successfully!");
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
      setError("");

      setTimeout(() => {
        setSuccess("");
      }, 2000);
    } catch (error) {
      console.log("Error updating password: ", error.message);
      setSuccess("");
      setError(error.message || "Error updating password.");
      setTimeout(() => {
        setError("");
      }, 3000);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await addPayPalDataToDatabase(userData.userId, formValues);
      setShowEditModal(false);
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const [newBoatType, setNewBoatType] = useState("");
  const handleAddBoatType = async (e) => {
    try {
      if (newBoatType) {
        const boatTypesRef = ref(
          getDatabase(),
          "portalSettings/settingsID/boatTypes"
        );
        await push(boatTypesRef, newBoatType);
        setSuccess(`${newBoatType} has been added to boat types.`);
        setTimeout(() => {
          setSuccess("");
        }, 1400);
      } else {
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleUpdatePlatformTax = async (e) => {
    try {
      const platformCutRef = ref(getDatabase(), "portalSettings/settingsID");
      await update(platformCutRef, {
        defaultAdminCut: platformCut,
      });
      setSuccess(
        `Platform percentage for bass boats has been updated to ${platformCutDisplay}%`
      );
      setTimeout(() => {
        setSuccess("");
      }, 1400);
    } catch (error) {
      console.log(error.message);
    }
  };
  const handleUpdateOtherTypePlatformTax = async (e) => {
    try {
      const platformCutRef = ref(getDatabase(), "portalSettings/settingsID");
      await update(platformCutRef, {
        defaultOtherBoatTypeAdminCut: platformOtherTypeCut,
      });
      setSuccess(
        `Platform percentage for other boat types has been updated to ${platformOtherTypeCutDisplay}%`
      );
      setTimeout(() => {
        setSuccess("");
      }, 1400);
    } catch (error) {
      console.log(error.message);
    }
  };

  return (
    <>
      <div className="row">
        <div className="col">
          <div className="page-description page-description-tabbed">
            <h1>Settings</h1>
            <ul className="nav nav-tabs mb-3" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  id="account-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#account"
                  type="button"
                  role="tab"
                  aria-controls="account"
                  aria-selected="true"
                >
                  Account
                </button>
              </li>

              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="security-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#security"
                  type="button"
                  role="tab"
                  aria-controls="security"
                  aria-selected="false"
                >
                  Security
                </button>
              </li>
              {userData.role === "Boat Owner" ? (
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="payout-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#payout"
                    type="button"
                    role="tab"
                    aria-controls="payout"
                    aria-selected="false"
                  >
                    Payout Account
                  </button>
                </li>
              ) : (
                ""
              )}
              {userData.role === "Admin" ? (
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="platform-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#platform"
                    type="button"
                    role="tab"
                    aria-controls="platform"
                    aria-selected="false"
                  >
                    Platform Settings
                  </button>
                </li>
              ) : (
                ""
              )}
              {userData.role === "Admin" ? (
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="general-settings-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#general-settings"
                    type="button"
                    role="tab"
                    aria-controls="general-settings"
                    aria-selected="false"
                  >
                    General Settings
                  </button>
                </li>
              ) : (
                ""
              )}
            </ul>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <div className="tab-content" id="myTabContent">
            {/* General Settings Tab Panel */}
            {userData.role === "Admin" && (
              <div
                className="tab-pane fade"
                id="general-settings"
                role="tabpanel"
                aria-labelledby="general-settings-tab"
              >
                <div className="card">
                  <div className="card-body">
                    <FeaturedBoats />
                  </div>
                </div>
              </div>
            )}

            {/* Account Tab Panel */}
            <div
              className="tab-pane fade show active"
              id="account"
              role="tabpanel"
              aria-labelledby="account-tab"
            >
              {userData.role === "Renter" ? (
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <Col>
                        <p>
                          Become a boat owner and open up your vessel for others
                          to experience. Answer questions, set your terms, and
                          start earning by renting out your boat. Join our
                          community of boat owners and enthusiasts today!{" "}
                          <IoBoatOutline style={{ fontSize: "27px" }} />{" "}
                        </p>
                        <Button
                          className="btn btn-primary"
                          onClick={openBecomeBoatOwnerModal}
                        >
                          Become A Boat Owner
                        </Button>
                      </Col>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="card">
                <div className="card-body">
                  <Row className="mb-2">
                    <Col xs={12}>
                      <Form.Label className="form-label">
                        Profile Picture
                      </Form.Label>
                      <div className="d-flex gap-3 align-items-center justify-content-center  ">
                        {userValues && userValues.avatar && (
                          <Image src={userValues.avatar} rounded width={120} />
                        )}
                        <Form.Control
                          type="file"
                          name="avatar"
                          onChange={(e) => handleSelectImage(e)}
                          accept="image/*"
                        />
                      </div>

                      {avatar && (
                        <>
                          <Cropper
                            src={avatar} // Image source
                            className="mt-3"
                            style={{ height: 400, width: "100%" }} // Styling for Cropper container
                            initialAspectRatio={16 / 9} // Initial aspect ratio for cropping
                            guides={false} // Display cropping guides
                            crop={onCrop} // Callback function triggered after cropping
                            ref={cropperRef} // Assign the ref to the Cropper component
                          />
                          <Button className="mt-3" onClick={handleUploadAvatar}>
                            Finish Cropping
                          </Button>
                        </>
                      )}
                    </Col>
                  </Row>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <label
                          htmlFor="settingsInputEmail"
                          className="form-label mb-0"
                        >
                          Email address
                        </label>
                        <span className="text-dark fw-bold text-decoration-underline" style={{cursor: 'pointer', fontSize: '0.9rem'}} onClick={() => initiateChange("email")}>Change</span>
                      </div>
                      <input
                        type="email"
                        className="form-control"
                        id="settingsInputEmail"
                        name="email"
                        aria-describedby="settingsEmailHelp"
                        value={userValues.email}
                        readOnly
                      />
                      <div id="settingsEmailHelp" className="form-text">
                        We'll never share your email with anyone else.
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <label
                          htmlFor="settingsPhoneNumber"
                          className="form-label mb-0"
                        >
                          Phone Number
                        </label>
                        <span className="text-dark fw-bold text-decoration-underline" style={{cursor: 'pointer', fontSize: '0.9rem'}} onClick={() => initiateChange("phone")}>Change</span>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        id="settingsPhoneNumber"
                        name="phone"
                        value={userValues.phone}
                        readOnly
                        placeholder="(xxx) xxx-xxxx"
                      />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-md-6">
                      <label
                        htmlFor="settingsInputFirstName"
                        className="form-label"
                      >
                        First Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={userValues.firstName}
                        name="firstName"
                        onChange={handleInputChange}
                        id="settingsInputFirstName"
                        placeholder="John"
                      />
                    </div>
                    <div className="col-md-6">
                      <label
                        htmlFor="settingsInputLastName"
                        className="form-label"
                      >
                        Last Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="lastName"
                        value={userValues.lastName}
                        onChange={handleInputChange}
                        id="settingsInputLastName"
                        placeholder="Doe"
                      />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-md-6">
                      <label
                        htmlFor="settingsInputDateOfBirth"
                        className="form-label"
                      >
                        Date of Birth
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        name="dateOfBirth"
                        value={userValues.dateOfBirth}
                        onChange={handleInputChange}
                        id="settingsInputDateOfBirth"
                        max={new Date().toISOString().split("T")[0]}
                      />
                    </div>
                  </div>
                  <Button
                    onClick={() => updateUserData(auth.currentUser.uid)}
                    className="btn btn-primary m-t-sm"
                  >
                    {loading ? (
                      <ThreeDots
                        visible={true}
                        height="22"
                        width="22"
                        color="#fff"
                        radius="20"
                        ariaLabel="three-dots-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                      />
                    ) : (
                      "Update"
                    )}
                  </Button>
                  {success && (
                    <Alert
                      style={{ width: "30%" }}
                      className="mt-3"
                      severity="success"
                    >
                      {success}
                    </Alert>
                  )}
                  {error && (
                    <Alert
                      style={{ width: "30%" }}
                      className="mt-3"
                      severity="error"
                    >
                      {error}
                    </Alert>
                  )}
                </div>
              </div>
            </div>

            <div
              className="tab-pane fade show"
              id="platform"
              role="tabpanel"
              aria-labelledby="platform-tab"
            >
              <Row>
                <Col>
                  {success && (
                    <Alert className="mb-3" severity="success">
                      {success}
                    </Alert>
                  )}
                </Col>
              </Row>
              <div className="card">
                <div className="card-body">
                  <div className="">
                    <h5>Platform settings</h5>
                  </div>
                  <div className="row m-t-xxl mt-4 p-0">
                    <div className="col-md-12">
                      <div className="row">
                        <Col>
                          <h6>Boat Types</h6>
                          <ul className="ks-cboxtags boat-types-admin mb-1 mt-3">
                            {boatTypes.map((boatType, index) => (
                              <li key={index}>
                                <input
                                  type="checkbox"
                                  id={boatType.id}
                                  value={boatType.id}
                                  checked={boatTypes.some(
                                    (item) => item.value === boatType.value
                                  )}
                                  onChange={() =>
                                    openBoatTypeModal(boatType.id)
                                  }
                                />
                                <label htmlFor={boatType.id}>
                                  {boatType.value}
                                </label>
                              </li>
                            ))}
                          </ul>
                          <Row className="mb-3">
                            <Col xs={12} md={4}>
                              <input
                                type="text"
                                placeholder="Boat Type"
                                value={newBoatType}
                                onChange={(e) => setNewBoatType(e.target.value)}
                                className="form-control"
                              />
                            </Col>
                            <Col xs={12} md={4}>
                              <button
                                className="btn btn-primary h-100"
                                onClick={(e) => handleAddBoatType(e)}
                              >
                                Add Boat Type
                              </button>
                            </Col>
                          </Row>
                        </Col>
                        <hr style={{ color: "#dddddd" }} />
                        <Row>
                          <Col className="mt-3">
                            <h6>Platform Percentage for Bass Boats</h6>
                          </Col>
                        </Row>
                        <Row className="mb-3 mt-2">
                          <Col xs={12} md={4}>
                            <input
                              type="number"
                              step="0.01"
                              min="0"
                              max="100"
                              value={platformCutDisplay}
                              onChange={(e) =>
                                handlePlatformCut(e.target.value)
                              }
                              className="form-control"
                            />
                          </Col>
                          <Col xs={12} md={4}>
                            <button
                              className="btn btn-primary h-100"
                              onClick={(e) => handleUpdatePlatformTax(e)}
                            >
                              Update
                            </button>
                          </Col>
                        </Row>
                        <hr style={{ color: "#dddddd" }} />
                        <Row>
                          <Col className="mt-3">
                            <h6>Platform Percentage for Other Boat Types</h6>
                          </Col>
                        </Row>
                        <Row className="mb-3 mt-2">
                          <Col xs={12} md={4}>
                            <input
                              type="number"
                              step="0.01"
                              min="0"
                              max="100"
                              value={platformOtherTypeCutDisplay}
                              onChange={(e) =>
                                handlePlatformOtherTypeCut(e.target.value)
                              }
                              className="form-control"
                            />
                          </Col>
                          <Col xs={12} md={4}>
                            <button
                              className="btn btn-primary h-100"
                              onClick={(e) =>
                                handleUpdateOtherTypePlatformTax(e)
                              }
                            >
                              Update
                            </button>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade show"
              id="payout"
              role="tabpanel"
              aria-labelledby="payout-tab"
            >
              <div className="card">
                <div className="card-body">
                  <div className="">
                    <h5>Payout Method</h5>
                    <span>
                      Payout for reservations are released after the{" "}
                      <b>rental date</b> and will take time to complete
                      depending on your selected payout method.
                    </span>
                    <span>
                      We can transfer payment using one of the following payout
                      methods:
                    </span>
                  </div>

                  {/* PayPal Section */}
                  {/* <div className="row m-t-xxl payout mt-4 p-0">
                                <div className="col-md-12">
                                    <div className='row payoutRow justify-content-between'>
                                        <div className='col-6 p-4 d-flex'>
                                            <svg width="100" viewBox="0 0 76 21" fill="none"><path d="M68.8731 5.43606H66.0813C65.8416 5.43606 65.6377 5.61007 65.6019 5.84634L65.4782 6.62768L65.282 6.34449C64.6773 5.46677 63.3296 5.17334 61.9836 5.17334C58.8966 5.17334 56.2609 7.51137 55.7474 10.7911C55.4813 12.4271 55.8591 13.9915 56.7872 15.0825C57.6402 16.0856 58.8565 16.5035 60.3057 16.5035C62.793 16.5035 64.1723 14.9042 64.1723 14.9042L64.0478 15.6804C64.0009 15.9772 64.2295 16.2434 64.5289 16.2434H67.0443C67.4427 16.2434 67.7821 15.9533 67.8444 15.5584L69.355 5.99732C69.4011 5.70304 69.1725 5.43606 68.8731 5.43606ZM64.9792 10.873C64.7114 12.4689 63.443 13.5403 61.8275 13.5403C61.018 13.5403 60.368 13.2801 59.9517 12.7871C59.5389 12.2975 59.3837 11.6006 59.5133 10.8244C59.7667 9.24207 61.053 8.13575 62.6438 8.13575C63.437 8.13575 64.0819 8.39932 64.5067 8.89661C64.934 9.39902 65.1029 10.1002 64.9792 10.873Z" fill="#19A4E1"></path><path d="M72.1671 0.450201L69.7727 15.6828C69.7258 15.9779 69.9544 16.244 70.2521 16.244H72.6592C73.0593 16.244 73.3988 15.954 73.4602 15.5591L75.8212 0.601179C75.8682 0.306046 75.6395 0.0390625 75.3419 0.0390625H72.6464C72.4084 0.0399155 72.2037 0.213924 72.1671 0.450201Z" fill="#19A4E1"></path><path d="M9.82713 0.0400391H3.99358C3.59438 0.0400391 3.25489 0.330054 3.19262 0.724132L0.833273 15.6829C0.786358 15.978 1.01496 16.2442 1.31435 16.2442H4.09935C4.49854 16.2442 4.83803 15.9542 4.9003 15.5592L5.53663 11.5246C5.59804 11.1297 5.93838 10.8397 6.33672 10.8397H8.18343C12.0261 10.8397 14.2439 8.98016 14.8231 5.29527C15.0841 3.68313 14.8341 2.41645 14.0793 1.52935C13.2502 0.555241 11.7796 0.0400391 9.82713 0.0400391ZM10.5001 5.5034C10.1811 7.59662 8.58178 7.59662 7.03532 7.59662H6.15504L6.7726 3.6874C6.80928 3.45112 7.01399 3.27711 7.25283 3.27711H7.65629C8.70972 3.27711 9.70345 3.27711 10.2169 3.87761C10.5232 4.23587 10.617 4.76813 10.5001 5.5034Z" fill="#0E4871"></path><path d="M27.2645 5.43606H24.4709C24.2329 5.43606 24.0274 5.61007 23.9907 5.84634L23.867 6.62768L23.6717 6.34449C23.0669 5.46677 21.7184 5.17334 20.3723 5.17334C17.2854 5.17334 14.6488 7.51137 14.1353 10.7911C13.8683 12.4271 14.2479 13.9915 15.176 15.0825C16.0272 16.0856 17.2453 16.5035 18.6945 16.5035C21.1818 16.5035 22.5611 14.9042 22.5611 14.9042L22.4366 15.6804C22.3896 15.9772 22.6182 16.2434 22.9159 16.2434H25.4322C25.8323 16.2434 26.1701 15.9533 26.2332 15.5584L27.743 5.99732C27.7907 5.70304 27.563 5.43606 27.2645 5.43606ZM23.3706 10.873C23.101 12.4689 21.8344 13.5403 20.2188 13.5403C19.4076 13.5403 18.7594 13.2801 18.3431 12.7871C17.9302 12.2975 17.7733 11.6006 17.9047 10.8244C18.1563 9.24207 19.4443 8.13575 21.0351 8.13575C21.8284 8.13575 22.4732 8.39932 22.898 8.89661C23.3237 9.39902 23.4926 10.1002 23.3706 10.873Z" fill="#0E4871"></path><path d="M42.1423 5.43604H39.3351C39.0673 5.43604 38.8157 5.5691 38.6638 5.79173L34.7921 11.4948L33.151 6.01436C33.0478 5.67146 32.7313 5.43604 32.3731 5.43604H29.6145C29.2793 5.43604 29.0464 5.76358 29.1531 6.07919L32.2451 15.1532L29.3382 19.2569C29.1096 19.5802 29.3399 20.0246 29.7348 20.0246H32.5386C32.8047 20.0246 33.0538 19.895 33.2047 19.6766L42.5415 6.19946C42.765 5.87703 42.5355 5.43604 42.1423 5.43604Z" fill="#0E4871"></path></svg>
                                        </div>
                                        <div className='col-md-2 p-4 d-flex flex-column'>
                                            <button className='btn btn-primary mb-1' onClick={openEditModal}>
                                              Edit
                                            </button>
                                            <Link className='btn btn-outline-primary mt-1'>Delete</Link>
                                        </div>
                                    </div>
                                </div>
                          </div> */}

                  {/* Stripe Connect Section */}
                  <div className="row mt-4">
                    <div className="col-md-12">
                      <StripeConnectSettings
                        userData={userData}
                        metaData={metaData}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="tab-pane fade"
              id="security"
              role="tabpanel"
              aria-labelledby="security-tab"
            >
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <h5>Account Security</h5>
                    <div className="col-md-6 mb-3">
                      <label
                        htmlFor="settingsCurrentPassword"
                        className="form-label"
                      >
                        Current Password
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        id="settingsCurrentPassword"
                        aria-describedby="settingsCurrentPassword"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        placeholder="&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <label
                        htmlFor="settingsNewPassword"
                        className="form-label"
                      >
                        New Password
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        aria-describedby="settingsNewPassword"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        placeholder="&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;"
                      />
                    </div>
                  </div>
                  <div className="row m-t-xxl">
                    <div className="col-md-6">
                      <label
                        htmlFor="settingsConfirmPassword"
                        className="form-label"
                      >
                        Confirm Password
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        aria-describedby="settingsConfirmPassword"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        placeholder="&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;"
                      />
                    </div>
                  </div>
                  <Button
                    onClick={handleSetNewPassword}
                    className="btn btn-primary m-t-sm"
                  >
                    Change Password
                  </Button>
                  {success && (
                    <Alert
                      style={{ width: "30%" }}
                      className="mt-3"
                      severity="success"
                    >
                      {success}
                    </Alert>
                  )}
                  {error && (
                    <Alert
                      style={{ width: "30%" }}
                      className="mt-3"
                      severity="error"
                    >
                      {error}
                    </Alert>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* PayPal Edit Modal */}
      <Modal
        show={showPayPalModal}
        onHide={closePaypalModal}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit PayPal</Modal.Title>
        </Modal.Header>
        <Modal.Body className="mb-2">
          {/* Add your modal form or content here */}
          <h6>Account Holder Information</h6>
          <p>Please enter the details associated with your PayPal account.</p>
          <Form onSubmit={handleSubmit}>
            <Row className="mt-3">
              <Col xs={6}>
                <label htmlFor="settingsInputCountry" className="form-label">
                  Country
                </label>
                <select
                  className="form-control"
                  onChange={(e) => handleChange(e)}
                  name="settingsInputCountry"
                >
                  <option>United States</option>
                </select>
              </Col>
              <Col xs={6}>
                <label htmlFor="settingsInputCurrency" className="form-label">
                  Currency
                </label>
                <select
                  className="form-control"
                  onChange={(e) => handleChange(e)}
                  name="settingsInputCurrency"
                >
                  <option>USD</option>
                </select>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col xs={6}>
                <label htmlFor="accountHolderFirst" className="form-label">
                  First Name <small>(account holder's name)</small>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={formValues?.accountHolderFirst}
                  onChange={(e) => handleChange(e)}
                  id="accountHolderFirst"
                  name="accountHolderFirst"
                  placeholder="John"
                />
              </Col>
              <Col xs={6}>
                <label htmlFor="accountHolderLast" className="form-label">
                  Last Name <small>(account holder's name)</small>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={formValues?.accountHolderLast}
                  onChange={(e) => handleChange(e)}
                  name="accountHolderLast"
                  id="accountHolderLast"
                  placeholder="Doe"
                />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col xs={12}>
                <label htmlFor="accountHolderEmail" className="form-label">
                  Email
                </label>
                <input
                  type="email"
                  className="form-control"
                  value={formValues?.accountHolderEmail}
                  onChange={(e) => handleChange(e)}
                  name="accountHolderEmail"
                  id="accountHolderEmail"
                  placeholder="john.doe@example.com"
                />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col xs={6}>
                <label htmlFor="accountHolderAddress" className="form-label">
                  Address
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={formValues?.accountHolderAddress}
                  onChange={(e) => handleChange(e)}
                  name="accountHolderAddress"
                  id="accountHolderAddress"
                  placeholder="2024 AB-123 Apt. 404"
                />
              </Col>
              <Col xs={6}>
                <label htmlFor="accountHolderCity" className="form-label">
                  City
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={formValues?.accountHolderCity}
                  onChange={(e) => handleChange(e)}
                  name="accountHolderCity"
                  id="accountHolderCity"
                  placeholder="Magnolia"
                />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col xs={6}>
                <label htmlFor="accountHolderState" className="form-label">
                  State/Province
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={formValues?.accountHolderState}
                  onChange={(e) => handleChange(e)}
                  name="accountHolderState"
                  id="accountHolderState"
                  placeholder="Texas"
                />
              </Col>
              <Col xs={6}>
                <label htmlFor="accountHolderZip" className="form-label">
                  Zip Code
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={formValues?.accountHolderZip}
                  onChange={(e) => handleChange(e)}
                  name="accountHolderZip"
                  id="accountHolderZip"
                  placeholder="77354"
                />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col xs={12} className="d-flex flex-column">
                <input
                  type="submit"
                  value={"Update"}
                  className="btn btn-primary"
                />
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        {/* Add additional modal components as needed */}
      </Modal>

      <Modal
        show={isBecomeBoatOwnerModalOpen}
        onHide={closeBecomeBoatOwnerModal}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Become A Boat Owner</Modal.Title>
        </Modal.Header>
        <Modal.Body className="mb-2">
          {/* Add your modal form or content here */}
          <h6>Please answer the questions below to become a boat owner.</h6>
          <Form onSubmit={handleBecomeBoatOwner}>
            {textQuestions.map((question, questionIndex) => (
              <Form.Group key={questionIndex} className="mt-4">
                <Row>
                  {question == "City" ||
                  "State/Province" ||
                  "Zip Code" ||
                  "" ? (
                    <Col xs={12}>
                      <Form.Label>{question}</Form.Label>
                      <Form.Control
                        rows={3}
                        name={`question_${questionIndex}`}
                        onChange={(e) => handleChange(e, question)}
                        required
                      />
                    </Col>
                  ) : (
                    <Col xs={12}>
                      <Form.Label>{question}</Form.Label>
                      <Form.Control
                        rows={3}
                        name={`question_${questionIndex}`}
                        onChange={(e) => handleChange(e, question)}
                        required
                      />
                    </Col>
                  )}
                </Row>
              </Form.Group>
            ))}
            <Row>
              <Col xs={12}>
                {success && <Alert severity="success">{success}</Alert>}
                <Button
                  className="w-100 p-2 mt-3"
                  variant="primary"
                  type="submit"
                >
                  Submit
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
        {/* Add additional modal components as needed */}
      </Modal>

      <Modal
        size="md"
        centered
        show={isBoatTypeModelOpen}
        onHide={closeBoatTypeModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <p>Are you sure you want to delete this boat type?</p>
            {success && (
              <Alert className="mt-3" severity="success">
                {success}
              </Alert>
            )}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn btn-danger" onClick={closeBoatTypeModal}>
            Cancel
          </Button>
          <Button className="btn btn-primary" onClick={handleRemoveBoatType}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showOtpModal} onHide={() => setShowOtpModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Update {otpType === 'email' ? 'Email' : 'Phone Number'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {otpError && <Alert severity="error" className="mb-3">{otpError}</Alert>}
          {otpStep === 0 && (
            <div>
              {otpType === 'email' ? (
                <p>To secure your account, we need to verify your identity. Please click the button below to send a verification code to your current email: <strong>{userData.email}</strong>.</p>
              ) : (
                <>
                  <p>To secure your account, we need to verify your identity. Please select where you'd like us to send the verification code:</p>
                  <Form.Group className="mb-4">
                    {userData.email && (
                      <Form.Check 
                        type="radio"
                        id="verify-email"
                        name="verifyMethod"
                        label={`Email (${userData.email})`}
                        checked={verifyMethod === 'email'}
                        onChange={() => setVerifyMethod('email')}
                        className="mb-2"
                      />
                    )}
                    {userData.phone && (
                      <Form.Check 
                        type="radio"
                        id="verify-phone"
                        name="verifyMethod"
                        label={`Phone (${userData.phone})`}
                        checked={verifyMethod === 'phone'}
                        onChange={() => setVerifyMethod('phone')}
                      />
                    )}
                  </Form.Group>
                </>
              )}
            </div>
          )}
          {otpStep === 1 && (
            <div>
              <p>A verification code has been sent to <strong>{verifyMethod === 'email' ? userData.email : userData.phone}</strong>.</p>
              <Form.Group className="mb-3">
                <Form.Label>Enter Verification Code</Form.Label>
                <Form.Control type="text" value={currentOtpValue} onChange={(e) => setCurrentOtpValue(e.target.value)} placeholder="6-digit code" />
              </Form.Group>
              <div className="d-flex justify-content-between align-items-center mt-2">
                <small className="text-muted">Didn't receive the code?</small>
                {resendTimer > 0 ? (
                  <small className="text-muted">Resend in {resendTimer}s</small>
                ) : (
                  <span className="text-primary" style={{cursor: 'pointer', fontSize: '0.875rem', fontWeight: 500}} onClick={handleRequestCurrent}>Resend Code</span>
                )}
              </div>
            </div>
          )}
          {otpStep === 2 && (
            <div>
              <p>Current {otpType} verified! Please enter your new {otpType} below.</p>
              <Form.Group className="mb-3">
                <Form.Label>New {otpType === 'email' ? 'Email Address' : 'Phone Number'}</Form.Label>
                <Form.Control 
                  type={otpType === 'email' ? 'email' : 'text'} 
                  value={newContactValue} 
                  onChange={(e) => setNewContactValue(e.target.value)} 
                  placeholder={otpType === 'email' ? 'new@email.com' : '(xxx) xxx-xxxx'} 
                />
              </Form.Group>
            </div>
          )}
          {otpStep === 3 && (
            <div>
              <p>A verification code has been sent to <strong>{newContactValue}</strong>.</p>
              <Form.Group className="mb-3">
                <Form.Label>Enter Verification Code</Form.Label>
                <Form.Control type="text" value={currentOtpValue} onChange={(e) => setCurrentOtpValue(e.target.value)} placeholder="6-digit code" />
              </Form.Group>
              <div className="d-flex justify-content-between align-items-center mt-2">
                <small className="text-muted">Didn't receive the code?</small>
                {resendTimer > 0 ? (
                  <small className="text-muted">Resend in {resendTimer}s</small>
                ) : (
                  <span className="text-primary" style={{cursor: 'pointer', fontSize: '0.875rem', fontWeight: 500}} onClick={handleRequestNew}>Resend Code</span>
                )}
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowOtpModal(false)}>Cancel</Button>
          {otpStep === 0 && (
            <Button variant="primary" onClick={handleRequestCurrent} disabled={otpLoading}>
              {otpLoading ? <ThreeDots height="20" width="20" color="#fff" /> : "Send Code"}
            </Button>
          )}
          {otpStep === 1 && (
            <Button variant="primary" onClick={handleVerifyCurrent} disabled={otpLoading || !currentOtpValue}>
              {otpLoading ? <ThreeDots height="20" width="20" color="#fff" /> : "Verify Code"}
            </Button>
          )}
          {otpStep === 2 && (
            <Button variant="primary" onClick={handleRequestNew} disabled={otpLoading || !newContactValue}>
              {otpLoading ? <ThreeDots height="20" width="20" color="#fff" /> : "Send Code"}
            </Button>
          )}
          {otpStep === 3 && (
            <Button variant="primary" onClick={handleVerifyNew} disabled={otpLoading || !currentOtpValue}>
              {otpLoading ? <ThreeDots height="20" width="20" color="#fff" /> : "Confirm Update"}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
}
